import { Button, Modal, Form, message, Typography } from "antd";
import React, { useState, useEffect, useMemo } from "react";
import "./internalErrorRca.css";
import { Link, useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { useContext } from "react";
import moment from "moment";
import { JsonToExcel } from "react-json-to-excel";
import "react-datetime/css/react-datetime.css";

import { exportJson } from "../../../utils/export";

import CustomLoader from "../../common/customLoader";
import media from "../../../media";
import TableContent from "../../../components/atoms/TableContent";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchInternalErrorRcaThunk,
  submitInternalErrorRcaThunk,
  updateInternalErrorRcaThunk,
} from "../../../store/thunks/internalErrorRcaThunk";
import { downloadAllThunk } from "../../../store/thunks/auditsThunk";
import { AvatarCell } from "../../../utils/Constants";
import DownloadAllModal from "../audits/downloadAllModal";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";

const InternalErrorRca = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location?.pathname?.split("/")?.[2];
  const [tableForm] = Form.useForm();
  const rawAccess = useSelector((state) => state.auth.access);
  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.qmsInternalErrorRca,
  );

  const internalErrorRcaState = useSelector(
    (state) => state.qmsInternalErrorRca,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;

  const [isInternalErrorRcaModalVisible, setIsInternalErrorRcaModalVisible] =
    useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedAudit, setSelectedAudit] = useState(null);
  const [internalErrorRcaLists, setInternalErrorRcaLists] = useState([]);
  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  {
    /*Declaring states*/
  }

  const [selectionType, setSelectionType] = useState("checkbox");
  const [isEditMode, setIsEditMode] = useState(false);

  const [listItems, setListItems] = useState([]);

  const [showLoader, setShowLoader] = useState(true);
  const [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false),
    [visible, setVisible] = useState(false),
    [isModalVisible, setIsModalVisible] = useState(false),
    [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(accessMap, "qMSEscalationsIERCA", "view");

  {
    /*Fetch the list of Audits*/
  }

  // const getInternalErrorRcaList = async (source = "", pagination = "") => {
  //   const allKeys = Object.keys(localStorage);
  //   let removeItems;
  //   switch (secureLocalStorage.getItem("fromComponent")) {
  //     case "audits": {
  //       removeItems = [
  //         "@secure.n.totalAuditedCount",
  //         "@secure.s.auditScore",
  //         "@secure.j.parameterSelectedList",
  //         "@secure.j.auditFormInput",
  //         "@secure.s.auditFormCall",
  //         "@secure.n.auditedQuestionScoreCount",
  //         "@secure.n.auditedQuestionCount",
  //         "@secure.j.countMap",
  //         "@secure.s.clickedLink",
  //         "@secure.j.timeStampsDetails",
  //         "@secure.n.weightageFlag",
  //         "@secure.j.updatedQMF",
  //         "@secure.s.savedAuditId",
  //         "@secure.b.auditedFormSubmit",
  //         "@secure.s.aID",
  //         "@secure.j.savePayloadRequestParams",
  //       ];
  //       break;
  //     }
  //     default: {
  //       break;
  //     }
  //   }
  //   allKeys &&
  //     allKeys.forEach((key) => {
  //       if (removeItems && removeItems.includes(key)) {
  //         localStorage.removeItem(key);
  //       }
  //     });

  //   let hasSearchedValue, searchKeyword;
  //   if (secureLocalStorage.getItem("hasSearchedValue")) {
  //     hasSearchedValue = "yes";
  //     searchKeyword = secureLocalStorage.getItem("searchKeyword");
  //   } else {
  //     hasSearchedValue = "";
  //     searchKeyword = "";
  //   }
  //   const searchIn = "internal-error-rca";
  //   const callActionFrom = source ? source : "";
  //   const globalStates = {
  //     globalState: globalState,
  //     setGlobalState: setGlobalState,
  //   };
  //   const { current, pageSize } = pagination;

  //   setSelectedRowKeys([]);
  //   const allStates = {
  //     searchData: searchData,
  //     setSearchData: setSearchData,
  //     selectedRowsArray: selectedRowsArray,
  //     setSelectedRowsArray: setSelectedRowsArray,
  //     showLoader: showLoader,
  //     setShowLoader: setShowLoader,
  //     pagination: pagination
  //       ? pagination
  //       : { current: 1, page: 1, pageSize: 100 },
  //     setPagination: setPagination,
  //     list: list,
  //     setList: setList,
  //     listItems,
  //     setListItems,
  //     allTransactionIdsArr: allTransactionIdsArr,
  //     setAllTransactionIdsArr: setAllTransactionIdsArr,
  //   };

  //   await HandleSearch(
  //     hasSearchedValue,
  //     searchIn,
  //     searchKeyword,
  //     callActionFrom,
  //     globalStates,
  //     allStates
  //   );
  // };

  // Fetch client-escalations
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchInternalErrorRcaThunk({
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
          }),
        ).unwrap();

        if (res?.meta?.allTransactionIdsArr) {
          setAllTransactionIdsArr(res.meta.allTransactionIdsArr);
        }
        if (res?.meta?.internalErrorRcaLists) {
          setInternalErrorRcaLists(res.meta.internalErrorRcaLists);
        }
      } catch (err) {
        console.error("Error fetching client-escalations:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, [currentPath, pagination.current, pagination.pageSize, dispatch]);

  const handleOk = async () => {
    let submitFormModal = "";
    if (isInternalErrorRcaModalVisible === true) {
      submitFormModal = "clickedOK";
    }

    const lIUId = secureLocalStorage.getItem("lIUId");

    let eweekdayweekend = selectedAudit
      ? getErrorWeekdayWeekend(selectedAudit?.transaction_date)
      : null;
    let dofweek = selectedAudit
      ? getDayoftheweek(selectedAudit?.transaction_date)
      : null;

    if (
      globalState?.eErrorRaiseDateVal &&
      globalState?.eFeedbackdate &&
      globalState?.eErrorImpact &&
      globalState?.eErrorStatus &&
      globalState?.eAdvisorShiftDuringError &&
      eweekdayweekend &&
      dofweek &&
      globalState?.eAgentTenure &&
      globalState?.eFeedbackStatus &&
      globalState?.eFeedbackShared &&
      globalState?.eRepeatedError &&
      globalState?.eCorrectiveActionTaken &&
      globalState?.ePreventiveActionTaken &&
      globalState?.eErrorcorrected &&
      globalState?.eErrorType &&
      globalState?.rcaLevelOneVal &&
      globalState?.rcaLevelTwoVal &&
      globalState?.rcaLevelThreeVal &&
      globalState?.rcaLevelFourVal
    ) {
      let eFeedbackdate = moment(globalState?.eFeedbackdateVal).format(
        "YYYY-MM-DD",
      );

      let eErrorRaiseDate = moment(globalState?.eErrorRaiseDateVal).format(
        "YYYY-MM-DD",
      );
      let createdAt = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      let createdBy = lIUId;
      let status = "ACTIVE";

      if (submitFormModal === "clickedOK") {
        setIsModalOpen(false);
        setIsInternalErrorRcaModalVisible(false);
        setVisible(false);

        const payload = {
          auditID: globalState?.auditID,
          errorRaiseDate: eErrorRaiseDate,
          feedbackdate: eFeedbackdate,
          errorImpact: globalState?.eErrorImpact,
          //errorInvestigationRemarks: globalState?.eErrorInvestigationRemarksVal,
          errorStatus: globalState?.eErrorStatus,
          advisorShiftDuringError: globalState?.eAdvisorShiftDuringError,
          erroronweekdayweekend: eweekdayweekend,
          dayoftheweek: dofweek,
          agentTenure: globalState?.eAgentTenure,
          feedbackStatus: globalState?.eFeedbackStatus,
          feedbackShared: globalState?.eFeedbackShared,
          repeatedError: globalState?.eRepeatedError,
          correctiveActionTaken: globalState?.eCorrectiveActionTaken,
          preventiveActionTaken: globalState?.ePreventiveActionTaken,
          errorcorrected: globalState?.eErrorcorrected,
          valueoflossprevented: globalState?.eValueoflosspreventedVal,
          errorType: globalState?.eErrorType,
          rcaLevelOne: globalState?.rcaLevelOneVal,
          rcaLevelTwo: globalState?.rcaLevelTwoVal,
          rcaLevelThree: globalState?.rcaLevelThreeVal,
          rcaLevelFour: globalState?.rcaLevelFourVal,
          status,
          createdAt,
          createdBy,
        };

        try {
          if (isEditMode) {
            const rcaId = selectedAudit?.internalerrorrcaID?._id;
            await dispatch(
              updateInternalErrorRcaThunk({
                id: rcaId,
                ...payload,
              }),
            ).unwrap();

            message.success("Updated successfully");
          } else {
            await dispatch(submitInternalErrorRcaThunk(payload)).unwrap();
            message.success("Added successfully");
          }

          setIsInternalErrorRcaModalVisible(false);
          setIsEditMode(false);

          dispatch(
            fetchInternalErrorRcaThunk({
              searchIn: currentPath,
              callActionFrom: currentPath,
              pagination,
            }),
          );
        } catch (error) {
          console.error("Submit RCA Error:", error);
          message.error("Something went wrong");
        }
      } else {
        setIsModalOpen(true);
        setIsInternalErrorRcaModalVisible(true);
      }
    } else {
      setIsModalOpen(true);

      setGlobalState((prevGlobalState) => ({
        ...prevGlobalState,
        eErrorRaiseDate: globalState?.eErrorRaiseDateVal
          ? globalState?.eErrorRaiseDateVal
          : "Error raise date is required",
        eFeedbackdate: globalState?.eFeedbackdateVal
          ? globalState?.eFeedbackdateVal
          : "Feedback date is required",
        eErrorImpact: globalState?.eErrorImpactVal
          ? globalState?.eErrorImpactVal
          : "Error impact is required",
        eErrorStatus: globalState?.eErrorStatusVal
          ? globalState?.eErrorStatusVal
          : "Error status is required",
        eAdvisorShiftDuringError: globalState?.eAdvisorShiftDuringErrorVal
          ? globalState?.eAdvisorShiftDuringErrorVal
          : "Advisor shift during error is required",
        eErroronweekdayweekend: eweekdayweekend
          ? eweekdayweekend
          : "Error on Weekday/Weekend is required",
        eDayoftheweek: dofweek ? dofweek : "Day of the week is required",
        eAgentTenure: globalState?.eAgentTenureVal
          ? globalState?.eAgentTenureVal
          : "Agent tenure is required",
        eFeedbackStatus: globalState?.eFeedbackStatusVal
          ? globalState?.eFeedbackStatusVal
          : "Feedback status is required",
        eFeedbackShared: globalState?.eFeedbackSharedVal
          ? globalState?.eFeedbackSharedVal
          : "Feedback shared in how many hrs after accepting error is required",
        eRepeatedError: globalState?.eRepeatedErrorVal
          ? globalState?.eRepeatedErrorVal
          : "Repeated error is required",
        eCorrectiveActionTaken: globalState?.eCorrectiveActionTakenVal
          ? globalState?.eCorrectiveActionTakenVal
          : "Corrective action taken is required",
        ePreventiveActionTaken: globalState?.ePreventiveActionTakenVal
          ? globalState?.ePreventiveActionTakenVal
          : "Preventive action taken (Action Plan) is required",
        eErrorcorrected: globalState?.eErrorcorrectedVal
          ? globalState?.eErrorcorrectedVal
          : "Error corrected in the system is required",
        eErrorType: globalState?.eErrorTypeVal
          ? globalState?.eErrorTypeVal
          : "Error Type is required",
        rcaLevelOne: globalState?.rcaLevelOneVal
          ? globalState?.rcaLevelOneVal
          : "RCA Level One is required",
        rcaLevelTwo: globalState?.rcaLevelTwoVal
          ? globalState?.rcaLevelTwoVal
          : "RCA Level Two is required",
        rcaLevelThree: globalState?.rcaLevelThreeVal
          ? globalState?.rcaLevelThreeVal
          : "RCA Level Three is required",
        rcaLevelFour: globalState?.rcaLevelFourVal
          ? globalState?.rcaLevelFourVal
          : "RCA Level Four is required",
      }));
    }
  };

  const handleCancel = () => {
    setIsInternalErrorRcaModalVisible(false);
    setIsEditMode(false);
  };

  {
    /*Export functionality on Audit Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  {
    /*Calling audit detail page on its ID's click*/
  }
  const handleAuditDetailClickedLink = () => {
    secureLocalStorage.setItem("clickedLink", "auditsDetailLinkClick");
    secureLocalStorage.setItem("fromComponent", "audits");
  };
  const exportColumns = [
    { key: "Form", path: "auditForm.formName" },
    { key: "Department", path: "department.name" },
    { key: "Client Name", path: "client.name" },
    { key: "Agent Emp Code", path: "agent.empID" },
    { key: "Agent Name", path: "agent.name" },
    { key: "Auditor Name", path: "auditor.name" },
    { key: "Insured Name", path: "insuredName" },
    { key: "Audit Form Type", path: "hasWeightage" },
    { key: "Transaction ID", path: "transaction_id" },
    { key: "Quality Score", path: "score" },
    {
      key: "Maximum Possible Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedMaxQuestionCount : "",
    },
    {
      key: "Actual Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedQuestionCount : "",
    },
    { key: "Status", path: "stage" },
    {
      key: "Audit Date",
      path: "createdAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Transaction Date",
      path: "transactionDate",
      formatter: (value) => (value ? moment(value).format("YYYY-MM-DD") : ""),
    },
    {
      key: "Error Raise Date",
      path: "internalerrorrcaID.errorRaiseDate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Feedback Date",
      path: "internalerrorrcaID.feedbackdate",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    { key: "Reporting Supervisor", path: "agentReportingSupervisor.name" },
    { key: "Error Description", path: "internalerrorrcaID.errorDescription" },
    { key: "Error Impact", path: "internalerrorrcaID.errorImpact" },
    // {
    //   key: "Error Investigation Remarks",
    //   path: "internalerrorrcaID.errorInvestigationRemarks",
    // },
    { key: "Error Status", path: "internalerrorrcaID.errorStatus" },
    {
      key: "Advisor Shift During Error",
      path: "internalerrorrcaID.advisorShiftDuringError",
    },
    {
      key: "Error on Weekday/Weekend",
      path: "internalerrorrcaID.erroronweekdayweekend",
    },
    { key: "Day of the week", path: "internalerrorrcaID.dayoftheweek" },
    { key: "Advisor Tenure", path: "internalerrorrcaID.agentTenure" },
    { key: "Feedback Status", path: "internalerrorrcaID.feedbackStatus" },
    {
      key: "Feedback shared in how many hrs after accepting error",
      path: "internalerrorrcaID.feedbackShared",
    },
    {
      key: "Repeated Error",
      path: "internalerrorrcaID.repeatedError",
    },
    {
      key: "Corrective Action Taken",
      path: "internalerrorrcaID.correctiveActionTaken",
    },
    {
      key: "Preventive Action Taken (Action Plan)",
      path: "internalerrorrcaID.preventiveActionTaken",
    },
    {
      key: "Error corrected in the system",
      path: "internalerrorrcaID.errorcorrected",
    },
    {
      key: "$ value of Loss prevented",
      path: "internalerrorrcaID.valueoflossprevented",
    },
    {
      key: "Error Area",
      path: "internalerrorrcaID.errorArea",
    },
    {
      key: "Error Type",
      path: "internalerrorrcaID.errorType",
    },
    {
      key: "Root Cause Analysis - L1",
      path: "internalerrorrcaID.rcaLevelOne",
    },
    {
      key: "Root Cause Analysis - L2",
      path: "internalerrorrcaID.rcaLevelTwo",
    },
    {
      key: "Root Cause Analysis - L3",
      path: "internalerrorrcaID.rcaLevelThree",
    },
    {
      key: "Root Cause Analysis - L4",
      path: "internalerrorrcaID.rcaLevelFour",
    },
  ];

  const openAddModal = () => {
    //setEditRecord(null);
    setModalOpen(true);
  };

  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      exportJson(
        selectedRows,
        internalErrorRcaLists,
        "InternalErrorRcaReport",
        exportColumns,
        setGlobalState,
        globalState,
      );
    },
  };

  const getErrorWeekdayWeekend = (dateString) => {
    if (!dateString) return null;

    const day = new Date(dateString).getUTCDay();

    return day === 0 || day === 6 ? "Weekend" : "Weekday";
  };
  const getDayoftheweek = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      timeZone: "UTC",
    });
  };

  const getMarkdownReason = (audit) => {
    if (!audit?.formContent) return "";

    try {
      const formContent =
        typeof audit.formContent === "string"
          ? JSON.parse(audit.formContent)
          : audit.formContent;

      const questions = formContent?.elements?.questions || [];

      const markdownQuestion = questions.find(
        (question) =>
          question?.qkey === "markdown-reason" ||
          question?.display_text ===
            "Reason for markdown (write in details what went wrong & what is the correct process):" ||
          question?.display_text ===
            "Reason for markdown (write in details what went wrong & what is the correct process:",
      );

      return (
        markdownQuestion?.selectedValue ?? markdownQuestion?.defaultValue ?? ""
      );
    } catch (error) {
      console.error("Error parsing formContent:", error);
      return "";
    }
  };

  {
    /*Defining columns for Audit Listing*/
  }
  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            AUDIT ID
          </div>
        );
      },
      dataIndex: "id",

      render: (text, row) => {
        const auditAuditorRole = row.auditor?.role;

        let auditType = "";

        if (auditAuditorRole === process.env.REACT_APP_AROLE) {
          auditType = process.env.REACT_APP_OPS_AUDITYPE;
        } else if (auditAuditorRole === process.env.REACT_APP_AUDROLE) {
          auditType = process.env.REACT_APP_AUDITORS_AUDITYPE;
        } else {
          auditType = process.env.REACT_APP_AUDITORS_AUDITYPE;
        }

        // Log row object to console
        return (
          <Link
            to={"/audits/" + row.id}
            state={{
              route: location.pathname,
              auditFormHasWeightage: row.hasWeightage,
              formMethd: row.formMethd,
              process: row.process?._id,
              auditType: auditType,
            }}
            style={{ color: "black" }}
          >
            <span
              className="rowStyle no-wrap"
              style={{ color: "#1875CB" }}
              onClick={handleAuditDetailClickedLink}
            >
              {text}
            </span>
          </Link>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Form
          </div>
        );
      },
      dataIndex: "form",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return (
          <span className="rowStyle no-wrap" title={text}>
            {truncatedText}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.transactionId.svg} alt="icon" />
            Transaction ID
          </div>
        );
      },
      dataIndex: "transaction_id",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return (
          <span className="rowStyle no-wrap" title={text}>
            {truncatedText}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />
            Auditor
          </div>
        );
      },
      dataIndex: "auditor",
      render: (auditor) => <AvatarCell avt={auditor} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.agent.svg} alt="icon" />
            Agent
          </div>
        );
      },
      dataIndex: "agent",
      render: (agent) => <AvatarCell avt={agent} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditScoree.svg} alt="icon" />
            Score
          </div>
        );
      },
      dataIndex: "score",
      render: (text, row) => <span className="rowStyle no-wrap">{text}%</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />
            Status
          </div>
        );
      },
      dataIndex: "stage",
      render: (text) => (
        <span className="rowStyle no-wrap">{text?.toUpperCase()}</span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Created At
          </div>
        );
      },
      dataIndex: "createdAt",
      render: (text, row) => <span className="rowStyle no-wrap">{text}</span>,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            RCA
          </div>
        );
      },
      dataIndex: "id",
      render: (text, row) => {
        const handleAddClick = () => {
          const markdownReason = row?.markdownReason;
          setGlobalState((prevGlobalState) => {
            return {
              ...prevGlobalState,

              eAdvisorShiftDuringError: null,
              eAdvisorShiftDuringErrorVal: null,

              eErrorRaiseDate: null,
              eErrorRaiseDateVal: null,

              eFeedbackdate: null,
              eFeedbackdateVal: null,

              eErrorImpact: null,
              eErrorImpactVal: null,

              eErrorStatus: null,
              eErrorStatusVal: null,

              eAdvisorShiftDuringError: null,
              eAdvisorShiftDuringErrorVal: null,

              eErroronweekdayweekend: null,
              eErroronweekdayweekendVal: null,

              eDayoftheweek: null,
              eDayoftheweekVal: null,

              eAgentTenure: null,
              eAgentTenureVal: null,

              eFeedbackStatus: null,
              eFeedbackStatusVal: null,

              eFeedbackShared: null,
              eFeedbackSharedVal: null,

              eRepeatedError: null,
              eRepeatedErrorVal: null,

              eCorrectiveActionTaken: null,
              eCorrectiveActionTakenVal: null,

              ePreventiveActionTaken: null,
              ePreventiveActionTakenVal: null,

              eErrorcorrected: null,
              eErrorcorrectedVal: null,

              eValueoflossprevented: null,
              eValueoflosspreventedVal: null,

              eErrorType: null,
              eErrorTypeVal: null,

              rcaLevelOne: null,
              rcaLevelOneVal: null,

              rcaLevelTwo: null,
              rcaLevelTwoVal: null,

              rcaLevelThree: null,
              rcaLevelThreeVal: null,

              rcaLevelFour: null,
              rcaLevelFourVal: null,
            };
          });
          setSelectedAudit(row);

          setIsViewMode(false);
          setIsInternalErrorRcaModalVisible(true);
        };
        const handleEditClick = (row) => {
          const rca = row.internalerrorrcaID;

          setSelectedAudit(row);
          setIsEditMode(true);
          setIsViewMode(false);
          setIsInternalErrorRcaModalVisible(true);

          setGlobalState((prev) => ({
            ...prev,

            auditID: row.id,

            eErrorRaiseDateVal: rca.errorRaiseDate
              ? moment(rca.errorRaiseDate)
              : null,

            eFeedbackdateVal: rca.feedbackdate
              ? moment(rca.feedbackdate)
              : null,

            eErrorImpactVal: rca.errorImpact,

            eErrorStatusVal: rca.errorStatus,
            eAdvisorShiftDuringErrorVal: rca.advisorShiftDuringError,
            eAgentTenureVal: rca.agentTenure,
            eFeedbackStatusVal: rca.feedbackStatus,
            eFeedbackSharedVal: rca.feedbackShared,
            eRepeatedErrorVal: rca.repeatedError,
            eCorrectiveActionTakenVal: rca.correctiveActionTaken,
            ePreventiveActionTakenVal: rca.preventiveActionTaken,
            eErrorcorrectedVal: rca.errorcorrected,
            eValueoflosspreventedVal: rca.valueoflossprevented,

            eErrorTypeVal: rca.errorType,

            rcaLevelOneVal: rca.rcaLevelOne,
            rcaLevelTwoVal: rca.rcaLevelTwo,
            rcaLevelThreeVal: rca.rcaLevelThree,
            rcaLevelFourVal: rca.rcaLevelFour,
          }));

          setIsInternalErrorRcaModalVisible(true);
        };

        // Log row object to console
        return (
          <>
            {row.internalerrorrcaID &&
            hasPermission(accessMap, "qMSEscalationsIERCA", "VIEWRCA") ? (
              <>
                <Link
                  to={"/escalations/internal-error-rca/" + row.id}
                  state={{
                    route: location.pathname,
                    auditFormHasWeightage: row.hasWeightage,
                    formMethd: row.formMethd,
                    process: row.process?._id,
                  }}
                  style={{ color: "black" }}
                >
                  <span className="rowstyle previewBy">
                    {text ? (
                      <span className="tableBtn escView bfont">
                        <i class="fa fa-eye" aria-hidden="true"></i> View
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </Link>
                {(isAdmin || isQC || isQCSupervisor) &&
                  hasPermission(
                    accessMap,
                    "qMSEscalationsIERCA",
                    "EDITRCA",
                  ) && (
                    <Typography.Link
                      onClick={() => handleEditClick(row)}
                      className="tableBtn bfont"
                      style={{ marginLeft: 8 }}
                    >
                      <i className="fa fa-pencil" /> Edit
                    </Typography.Link>
                  )}
              </>
            ) : (
              hasPermission(accessMap, "qMSEscalationsIERCA", "ADDRCA") && (
                <Typography.Link
                  onClick={handleAddClick}
                  className="tableBtn bfont"
                >
                  + Add
                </Typography.Link>
              )
            )}
          </>
        );
      },
    },
  ];

  /*Audit Date*/
  var today = moment();
  var valid = function (current) {
    return current.isBefore(today);
  };

  /*Audit Date*/

  const [editingKey, setEditingKey] = useState("");
  const [backAuditDateChecked, setBackAuditDateChecked] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const cancel = () => {
    setEditingKey("");
  };

  const handleCheckboxChange = (e) => {
    setBackAuditDateChecked(e.target.checked);
  };

  const [form] = Form.useForm();

  {
    /*begin:: Download all audits*/
  }
  const onCreateDownloadAll = async (values) => {
    secureLocalStorage.setItem("isActiveLoad", "activeLoad");
    const [startMonth, endMonth] = values?.month || [];

    const monthFrom = startMonth?.format("YYYY-MM");
    const monthTo = endMonth?.format("YYYY-MM");

    try {
      let hasSearchedValue, searchKeyword;
      if (secureLocalStorage.getItem("hasSearchedValue")) {
        hasSearchedValue = "yes";
        searchKeyword = secureLocalStorage.getItem("searchKeyword");
      } else {
        hasSearchedValue = "";
        searchKeyword = "";
      }

      const response = await dispatch(
        downloadAllThunk({
          searchKeyword,
          monthFrom,
          monthTo,
          role: secureLocalStorage.getItem("role"),
          lIUId: secureLocalStorage.getItem("lIUId"),
          exportOf: "audit_internalRca",
          exportColumns,
        }),
      ).unwrap();

      // Check if the response data is a Blob
      if (response instanceof Blob) {
        // Create a Blob from the response
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "internal-error-rca.xlsx";

        // Append to the DOM
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Revoke the Blob URL after the download
        window.URL.revokeObjectURL(link.href);

        // Clean up
        document.body.removeChild(link);

        message.success("Download done successfully");
        setIsDownloadModalOpen(false);
        secureLocalStorage.setItem("isActiveLoad", "");
      } else {
        console.error("Expected a Blob, but got:", response);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadAll = async () => {
    secureLocalStorage.setItem("isActiveLoad", "false");
    setIsDownloadModalOpen(true);
  };

  {
    /*end: Download all audits*/
  }

  const isAdmin = secureLocalStorage.getItem("role") === "admin";
  const isAuditor = secureLocalStorage.getItem("role") === "auditor";
  const isQC = secureLocalStorage.getItem("role") === "qc";
  const isTL = secureLocalStorage.getItem("role") === "tl";
  const isQCSupervisor = isQC && secureLocalStorage.getItem("manager") === null;

  const hasSelectedRows =
    Array.isArray(globalState.selectedRowKeysChildInfo) &&
    globalState.selectedRowKeysChildInfo.length > 0;

  if (!hasViewAccess) {
    return <Unauthorized />;
  }
  return (
    <div className="all-content internalErrRca">
      <CustomLoader showLoader={showLoader} />
      <TopContainerHeader
        sectionTitle="Internal Error RCA"
        sectionDescription={showLoader ? "Loading..." : `${count || 0} Found`}
        hasSectionButton={true}
        sectionButtons={[
          {
            key: "download-selected",
            isVisible:
              hasSelectedRows &&
              hasPermission(
                accessMap,
                "qMSEscalationsIERCA",
                "DOWNLOADASEXCEL",
              ),
            itemType: "downloadAsExcel",
            itemName: "",
            renderComponent: (
              <JsonToExcel
                title={
                  <>
                    <img src={media.downloadIcon.svg} alt="icon" />
                    &nbsp;Download as Excel
                  </>
                }
                data={
                  Array.isArray(globalState.exportInternalErrorRcaReportJson)
                    ? globalState.exportInternalErrorRcaReportJson
                    : []
                }
                fileName="internalErrorRcaReport"
                btnClassName="defaultBtn defaultGreyBtn"
              />
            ),
            itemClassName: "",
          },
          {
            key: "download-all",
            isVisible: hasPermission(
              accessMap,
              "qMSEscalationsIERCA",
              "DOWNLOADALL",
            ),
            itemType: "",
            itemName: "Download All",
            itemClassName: "downloadAllLoader-container defaultGreyBtn",
            itemIcon: <img src={media.downloadIcon.svg} alt="icon" />,
            onClick: () => handleDownloadAll(),
          },
        ]}
        hasFilter={false}
        buttonTitle="Add New"
      />
      <div className="all-table-holder">
        <Form form={tableForm} component={false}>
          <TableContent
            rowSelection={rowSelection}
            bordered={false}
            columns={columns}
            dataSource={list}
            pagination={tablePagination}
          />
        </Form>
      </div>

      <div className="downloadAllLoader-container">
        <DownloadAllModal
          open={isDownloadModalOpen}
          setVisible={setIsDownloadModalOpen}
          headermodaltitle="Download Internal Error RCA Report"
          onCreate={onCreateDownloadAll}
          pickerType="monthRange"
        />
      </div>

      <Modal
        className="all-modal cusWidthModal modal-lg"
        onCancel={handleCancel}
        onOk={handleOk}
        title={
          <div className="headermodaltitle">
            {isEditMode ? "Edit Internal Error RCA" : "Add Internal Error RCA"}
          </div>
        }
        open={isInternalErrorRcaModalVisible}
        bodyStyle={{ height: "70vh", overflowY: "scroll" }}
        footer={[
          <div className="modalBtns">
            <Button
              key="back"
              className="defaultBtn defaultGreyBtn"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button key="submit" className="defaultBtn" onClick={handleOk}>
              {isEditMode ? "Update" : "Create"}
            </Button>
          </div>,
        ]}
        width={"50vw"}
      >
        {children &&
          React.cloneElement(children, {
            selectedAudit,
            erroronweekdayweekend: selectedAudit
              ? getErrorWeekdayWeekend(selectedAudit?.transaction_date)
              : null,
            dayoftheweek: selectedAudit
              ? getDayoftheweek(selectedAudit?.transaction_date)
              : null,
          })}
      </Modal>
    </div>
  );
};
export default InternalErrorRca;
